import { cookie } from '@pmi/pmi-iqos-shared-react'

export default class IqospherePackCode {
  constructor(api) {
    this.api = api
  }

  getPackCodesQoins = async () => {
    const res = await this.api.get('/packcode/qoins', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock('getPackCodesQoins')
    })
    return res
  }
}
